// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const ListIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="ListIcon" ref={forwardedRef} {...props}>
      <path d="M6 4.25h12v1.498H6z" />
      <path d="M6 9.251h12v1.498H6z" />
      <path d="M18 14.252H6v1.498h12z" />
      <path d="M4 5a1 1 0 1 1-2 0 1 1 0 0 1 2 0" />
      <path d="M4 15a1 1 0 1 1-2 0 1 1 0 0 1 2 0" />
      <path d="M4 10a1 1 0 1 1-2 0 1 1 0 0 1 2 0" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const ListIcon = /* @__PURE__ */ Object.assign(ListIconComponent, {
  displayName: 'ListIcon',
});
